import styled from 'styled-components/macro';

const FieldLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0;
`;

export default FieldLabel;
